import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchReleaseNotes, selectAllReleaseNotes, selectReleaseNotesError, selectReleaseNotesStatus } from "./releaseNotesSlice";
import Spinner from "../../components/Spinner";
import { ReleaseNoteDisplay } from "./EditReleaseNoteForm";
import { useEffect, useState } from "react";
import { selectCurrentUserAdmin } from "../currentUser/currentUserSlice";
import AddReleaseNoteForm from "./AddReleaseNoteForm";

const ReleaseNotesPage = () => {

    const dispatch = useDispatch();
    const releaseNotes = useSelector(selectAllReleaseNotes);
    const releaseNotesStatus = useSelector(selectReleaseNotesStatus);
    const releaseNotesError = useSelector(selectReleaseNotesError);

    const toolNames = [];
    for (const releaseNote of releaseNotes) {
        if (releaseNote.toolname && !toolNames.includes(releaseNote.toolname)) {
            toolNames.push(releaseNote.toolname);
        }
    }

    toolNames.sort();
    const { toolName } = useParams();
    let toolname = "";
    if (toolName) {
        toolname = toolName.replace("%20", " ").replace("FEvIR", "FEvIR®:")
            .replace("Computable Publishing", "Computable Publishing®:")
            .replace("FEvIR®: Converter", "FEvIR Converter")
            .replace("Fast Evidence Interoperability Resources (FEvIR®:) Platform", "Fast Evidence Interoperability Resources (FEvIR®) Platform")
            .replace("FEvIR®: Platform", "FEvIR® Platform");
        console.log(toolName)
        console.log(toolname)
    }
    const isAdmin = useSelector(selectCurrentUserAdmin);

    useEffect(() => {
        if (releaseNotesStatus === 'idle') {
            dispatch(fetchReleaseNotes());
        }
    }, [releaseNotesStatus, dispatch]);

    const [filterReleaseNotesByStringState, setFilterReleaseNotesByStringState] = useState({ "searchString": "" });
    const [filterReleaseNotesByToolnameState, setFilterReleaseNotesByToolNameState] = useState({ "toolname": "" });
    const [filteredReleaseNotesState, setFilteredReleaseNotesState] = useState(releaseNotes);

    useEffect(() => {
        let toolname = "";
        if (toolName) {
            toolname = toolName.replace("%20", " ").replace("FEvIR", "FEvIR®:")
                .replace("Computable Publishing", "Computable Publishing®:")
                .replace("FEvIR®: Converter", "FEvIR Converter")
                .replace("Fast Evidence Interoperability Resources (FEvIR®:) Platform", "Fast Evidence Interoperability Resources (FEvIR®) Platform")
                .replace("FEvIR®: Platform", "FEvIR® Platform");
            console.log(toolName)
            console.log(toolname)
        }
        setFilterReleaseNotesByToolNameState({ "toolname": toolname || "" });
    }, [toolName])

    useEffect(() => {
        if (releaseNotes.length) {
            let filteredReleaseNotes = JSON.parse(JSON.stringify(releaseNotes));
            if (filterReleaseNotesByStringState?.searchString) {
                filteredReleaseNotes = filteredReleaseNotes
                    .filter((item) => (item?.toolname.includes(filterReleaseNotesByStringState.searchString) ||
                        item?.releasedescription.includes(filterReleaseNotesByStringState.searchString) ||
                        item?.releasenumber.includes(filterReleaseNotesByStringState.searchString) ||
                        item?.dateDisplay.includes(filterReleaseNotesByStringState.searchString)
                    ));
            }
            if (filterReleaseNotesByToolnameState?.toolname) {
                console.log(filterReleaseNotesByToolnameState.toolname)
                filteredReleaseNotes = filteredReleaseNotes.filter((item) =>
                    (item?.toolname === filterReleaseNotesByToolnameState.toolname)
                );
            }
            console.log(filteredReleaseNotes)
            setFilteredReleaseNotesState(filteredReleaseNotes);
        }
    }, [filterReleaseNotesByStringState, filterReleaseNotesByToolnameState, releaseNotes]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const searchString = e.currentTarget.searchString.value;
        setFilterReleaseNotesByStringState({ "searchString": searchString });
        const toolname = e.currentTarget.toolname.value || "";
        setFilterReleaseNotesByToolNameState({ "toolname": toolname });
    };

    return <>
        <div className="pageheader">
            <h1>Release Notes </h1>
        </div>
        {releaseNotesStatus === 'loading' && <Spinner />}
        {releaseNotesStatus === 'failed' && <div>{releaseNotesError}</div>}
        {releaseNotesStatus === 'succeeded' && <div className="pagecontent">
            <div style={{ margin: "8px" }} />
            <form onSubmit={handleSubmit}>
                <label htmlFor="searchString">Filter Release Notes by: </label>
                <input type="text" style={{ width: "700px" }} id="searchString" defaultValue="" />
                <br />
                <label htmlFor="toolname">Filter Release Notes by Tool:</label>
                <select id="toolname" name="toolname" defaultValue={toolname}>
                    <option key="clear" value=""></option>
                    {toolNames.map((toolname, index) => {
                        return <option key={index} value={toolname}>{toolname}</option>
                    })}
                </select>
                <br />
                <button>Search</button>
            </form>
            <br />
            {filteredReleaseNotesState.map((releaseNote, unitIndex) => {
                return <div key={unitIndex}>
                    <ReleaseNoteDisplay releaseNote={releaseNote} />
                    {isAdmin && <p><Link to={`/releasenotes/${releaseNote.id}`}>Edit Release Note {releaseNote.releasenumber}</Link></p>}
                </div>
            })}
            {isAdmin && <AddReleaseNoteForm />}
        </div>}
    </>;
};

export { ReleaseNotesPage };